import fecha from 'fecha';
import * as tune from '@mmt/legacy-commons/Common/utils/TuneTrackerUtils';
import {DATE_MONTH_YEAR_FORMAT, getDataFromAsynStorage, setDataToAsyncStorage} from './RailsConstant';
import { isApp } from './device';

export const TuneEvent = {
  RAIL_LANDING: 'Train Landing',
  RAIL_SEARCH_CLICK: 'Train Search',
  RAIL_LISTING: 'Train Listing',
  RAIL_REVIEW: 'Train Review',
  RAIL_SUCCESS: 'Train Transaction'
};

export const tuneLandingTracker = () => {
  try {
    if (isApp()) {
      const params = {};
      params[tune.EVENT_NAME] = TuneEvent.RAIL_LANDING;
      tune.trackTune(params);
    }
  } catch (e) {
    console.log('error is', e);
  }
};
export const tuneListingTracker = (request) => {
  try {
    if (isApp()) {
      const {
        src,
        dest,
        deptDate
      } = request;

      const params = {};
      params[tune.EVENT_NAME] = TuneEvent.RAIL_SEARCH_CLICK;
      params[tune.ATTRIBUTE_1] = src.cityName;
      params[tune.ATTRIBUTE_2] = dest.cityName;
      params[tune.ATTRIBUTE_3] = fecha.format(deptDate, DATE_MONTH_YEAR_FORMAT);
      tune.trackTune(params);
    }
  } catch (e) {
    console.log('error is', e);
  }
};

export const tuneRailsListingLoadTracker = (request) => {
  try {
    if (isApp()) {
      const params = {};
      params[tune.EVENT_NAME] = TuneEvent.RAIL_LISTING;
      params[tune.ATTRIBUTE_1] = request.from;
      params[tune.ATTRIBUTE_2] = request.to;
      params[tune.ATTRIBUTE_3] = request.date;
      params[tune.ATTRIBUTE_4] = request.travelByAc;
      tune.trackTune(params);
    }
  } catch (e) {
    console.log('error is ', e);
  }
};

export const tuneRailsReviewLoadTracker = (request) => {
  try {
    if (isApp()) {
      setDataToAsyncStorage('RAIL_TUNE_TRACKING_DATA', JSON.stringify(request));
      const params = {};
      params[tune.EVENT_NAME] = TuneEvent.RAIL_REVIEW;
      params[tune.ATTRIBUTE_1] = request.fromTo;
      params[tune.ATTRIBUTE_2] = request.date;
      params[tune.ATTRIBUTE_3] = request.trainNameDuration;
      params[tune.ATTRIBUTE_4] = request.paxCountClassQuotaAvail;
      params[tune.ATTRIBUTE_5] = request.mmtId;
      params[tune.ATTRIBUTE_6] = request.price;
      tune.trackTune(params);
    }
  } catch (e) {
    console.log('error is', e);
  }
};

export const tuneRailsSuccessPageLoadTracker = async (mmtId) => {
  try {
    if (isApp()) {
      const request = JSON.parse(await getDataFromAsynStorage('RAIL_TUNE_TRACKING_DATA'));
      const params = {};
      const {paxCountClassQuotaAvail} = request;
      const paxCountClassQuotaAvailArray = paxCountClassQuotaAvail.split('|');
      const paxCountClassQuota =
        paxCountClassQuotaAvailArray.slice(0, paxCountClassQuotaAvailArray.length - 1)
          .reduce((acc, item) => (`${acc}|${item}`), '');
      const bkgId = `bkgId: <${mmtId}>`
      params[tune.EVENT_NAME] = TuneEvent.RAIL_SUCCESS;
      params[tune.ATTRIBUTE_1] = request.fromTo;
      params[tune.ATTRIBUTE_2] = request.date;
      params[tune.ATTRIBUTE_3] = request.trainNameDuration;
      params[tune.ATTRIBUTE_4] = paxCountClassQuota;
      params[tune.ATTRIBUTE_5] = bkgId;
      params[tune.ATTRIBUTE_6] = request.price;
      tune.trackTune(params);
    }
  } catch (e) {
    console.log('error is', e);
  }
};
